import { createAction, createReducer } from 'redux-act'
import { push } from 'connected-react-router'
import { pendingTask, begin, end } from 'react-redux-spinner'
import { setCompany, loginError } from './login'
import { Auth } from 'aws-amplify'
import { queryCache } from 'react-query'
import { clearLogin } from 'ducks/login'
import axios from 'axios'

const REDUCER = 'app'
const NS = `@@${REDUCER}/`

const _setFrom = createAction(`${NS}SET_FROM`)
const _setLoading = createAction(`${NS}SET_LOADING`)
const _setHideLogin = createAction(`${NS}SET_HIDE_LOGIN`)

export const addSubmitForm = createAction(`${NS}ADD_SUBMIT_FORM`)
export const clearApp = createAction(`${NS}CLEAR`)
export const deleteDialogForm = createAction(`${NS}DELETE_DIALOG_FORM`)
export const deleteSubmitForm = createAction(`${NS}DELETE_SUBMIT_FORM`)
export const notLoggedIn = createAction(`${NS}NOT_LOGGED_IN`)
export const setActiveDialog = createAction(`${NS}SET_ACTIVE_DIALOG`)
export const setLayoutState = createAction(`${NS}SET_LAYOUT_STATE`)
export const setUpdatingContent = createAction(`${NS}SET_UPDATING_CONTENT`)
export const setUserState = createAction(`${NS}SET_USER_STATE`)

export const setLoading = isLoading => {
  const action = _setLoading(isLoading)
  action[pendingTask] = isLoading ? begin : end
  return action
}

export const getAuthorizationHeader = async (dispatch) => {
  try {
    const session = await Auth.currentSession()
    return `Bearer ${session.accessToken.jwtToken}`
  } catch (err) {
    console.error('getAuthorizationHeader', err)
    dispatch(notLoggedIn('/cobrancas/emitir'))
    dispatch(push('/login'))
  }
}

export const getCompany = (state) => {
  return state.login.company || parseInt(window.localStorage.getItem('login.company'), 10)
}

export const isAuth = async () => {
  try {
    const session = await Auth.currentSession()

    if (!session) {
      return false
    }
    
    axios.defaults.headers.common['Authorization'] = `Bearer ${session.accessToken.jwtToken}`
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}

export const logout = () => async (dispatch, getState) => {
  const state = getState()
  dispatch(setCompany(0))

  queryCache.clear()
  if (!state.login.newPasswordRequired) {
    dispatch(loginError(null))
  }

  await Auth.signOut()

  window.localStorage.clear()
  dispatch(clearApp())
  dispatch(clearLogin())
  dispatch(push('/login'))
}

const initialState = {
  // APP STATE
  from: '',
  isUpdatingContent: false,
  isLoading: false,
  activeDialog: '',
  dialogForms: {},
  submitForms: {},
  isHideLogin: false,

  // LAYOUT STATE
  layoutState: {
    isMenuTop: false,
    menuMobileOpened: false,
    menuCollapsed: true,
    menuShadow: true,
    themeLight: false,
    squaredBorders: false,
    borderLess: true,
    fixedWidth: false,
    settingsOpened: false
  },

  // USER STATE
  userState: {
    email: '',
    role: ''
  }
}

export default createReducer(
  {
    [_setFrom]: (state, from) => ({ ...state, from }),
    [_setLoading]: (state, isLoading) => ({ ...state, isLoading }),
    [_setHideLogin]: (state, isHideLogin) => ({ ...state, isHideLogin }),
    [setUpdatingContent]: (state, isUpdatingContent) => ({ ...state, isUpdatingContent }),
    [setUserState]: (state, { userState }) => ({ ...state, userState }),
    [setLayoutState]: (state, param) => {
      const layoutState = { ...state.layoutState, ...param }
      const newState = { ...state, layoutState }
      window.localStorage.setItem('app.layoutState', JSON.stringify(newState.layoutState))
      return newState
    },
    [setActiveDialog]: (state, activeDialog) => {
      const result = { ...state, activeDialog }
      if (activeDialog !== '') {
        const id = activeDialog
        result.dialogForms = { ...state.dialogForms, [id]: true }
      }
      return result
    },
    [deleteDialogForm]: (state, id) => {
      const dialogForms = { ...state.dialogForms }
      delete dialogForms[id]
      return { ...state, dialogForms }
    },
    [addSubmitForm]: (state, id) => {
      const submitForms = { ...state.submitForms, [id]: true }
      return { ...state, submitForms }
    },
    [deleteSubmitForm]: (state, id) => {
      const submitForms = { ...state.submitForms }
      delete submitForms[id]
      return { ...state, submitForms }
    },
    [notLoggedIn]: (state, location) => {
      return {
        ...state,
        previousLocation: location
      }
    },
    [clearApp]: (state, from) => {
      return {
        ...initialState
      }
    }
  },
  initialState
)
